@let blok = block();

<p>{{ blok.title }}</p>
